// @flow
import { httpClient } from 'angieslist-app-platform';
import _ from 'lodash';
import type { Category, CategoryOptInToSet, MetricCategoryStars, MetricsAggregationStars } from '../../types';

export type GetServiceProviderCategoriesRequest = string | number;

export type GetCategoriesWithMetricsRequest = string | number;
export type GetCategoriesWithMetricsResponse = {
  categories: MetricCategoryStars[],
  metricAggregation: MetricsAggregationStars,
  displayGrade: string,
  displayReviewCount: number,
};

export type AddCategoriesRequest = {
  serviceProviderId: string | number,
  categories: Array<Category>,
}
export type AddCategoriesResponse = {
  categoryAssociationIds: Array<number>,
}

export type RemoveCategoriesRequest = {
  serviceProviderId: string | number,
  categoryIds: Array<number>,
}
export type RemoveCategoriesResponse = null;

export type SetCategoryOptInsRequest = {
  categories: Array<CategoryOptInToSet>,
}

export const getServiceProviderCategories =
  (serviceProviderId: GetServiceProviderCategoriesRequest): any =>
    httpClient.get(
      `/gateway/service-provider-profile/v1/service_provider/${serviceProviderId}/categories`,
      {
        headers: {
          'X-ANGI-CallerId': serviceProviderId,
        },
      },
    );

export const getCategoriesWithMetrics =
(serviceProviderId : GetCategoriesWithMetricsRequest): any =>
  httpClient.get(`/gateway/office-home/v3/service_provider/${serviceProviderId}/categories/metrics`, {
    headers: {
      'X-ANGI-CallerType': 'ServiceProvider',
      'X-ANGI-CallerId': serviceProviderId,
    },
  });

export const addCategoriesToServiceProvider =
  ({ serviceProviderId, categories }: AddCategoriesRequest): any =>
    httpClient.post(
      '/gateway/service-provider-management/v1/service_providers/category_association',
      {
        body: {
          categoryAssociations: _.map(categories, category => ({
            serviceProviderId: parseInt(serviceProviderId, 10),
            categoryId: category.id,
            isVerified: false,
          })),
        },
      },
    );

export const removeCategoriesFromServiceProvider = ({
  serviceProviderId,
  categoryIds,
}: RemoveCategoriesRequest): any =>
  httpClient.del(
    '/gateway/service-provider-management/v1/service_providers/category_association',
    {
      body: {
        serviceProviderId: parseInt(serviceProviderId, 10),
        categoryIds,
      },
    },
  );

export const setCategoryOptIns = (
  serviceProviderId: string | number,
  optIns: Array<CategoryOptInToSet>,
): any =>
  httpClient.post(
    `/gateway/office-home/v1/service_provider/${serviceProviderId}/categories/optins`,
    {
      headers: {
        'X-ANGI-CallerId': serviceProviderId,
      },
      body: {
        categories: optIns,
      },
    },
  );




// WEBPACK FOOTER //
// ./src/app/common/categories/categoriesService.js